import { ScenarioType } from 'shared/enums/scenario-type';
import { jsonParseWithLowerCaseKeys, jsonParseWithUpperCaseKeys } from 'shared/utils/string-utils';

export default interface OrganisationUnitScenario {
  id: string;
  isActive: boolean;
  scenarioType: ScenarioType;
  configuration: string | undefined;
}

export const serialize = (organisationUnitScenario: OrganisationUnitScenario): OrganisationUnitScenario => {
  if (organisationUnitScenario.configuration) {
    const configuration = jsonParseWithLowerCaseKeys(organisationUnitScenario.configuration);

    organisationUnitScenario.configuration = jsonParseWithUpperCaseKeys(configuration);
  }

  return organisationUnitScenario;
};
